import React from 'react';
import { CSSObject } from '@emotion/react';
import useTheme from '@cvent/blocks/hooks/useTheme';
import { useTranslate } from 'nucleus-text';
import { injectTestId } from '@cvent/nucleus-test-automation';
import LandingPageSubheader from './LandingPageSubheader';

const useStyles = (): Record<string, CSSObject> => {
  const { font, block, size } = useTheme();

  return {
    registrationNotYetOpen: {
      background: block.container,
      height: '132px',
      width: '544px',
      borderRadius: size.border.radius.fiveX,
      paddingTop: '48px',
      paddingBottom: '48px',
      fontSize: font.base.size.h2
    }
  };
};

function RegistrationNotYetOpen(): JSX.Element {
  const { registrationNotYetOpen } = useStyles();
  const { translate } = useTranslate();

  return (
    <div css={registrationNotYetOpen} {...injectTestId('registration-not-yet-open')}>
      <LandingPageSubheader subheaderText={translate('LandingPage-Tag-RegistrationNotYetOpen')} />
    </div>
  );
}

export default RegistrationNotYetOpen;
